import { useEffect, useState, useCallback } from "react";
import { collection, onSnapshot, doc, setDoc, serverTimestamp } from "firebase/firestore";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { db } from "../firebase";

export default function useBlockedUsers() {
  const [uid, setUid] = useState(getAuth().currentUser?.uid || null);
  const [blockedIds, setBlockedIds] = useState([]);

  // Keep uid in sync, so pages opened directly (e.g. from a shared link) still work
  useEffect(() => {
    const unsub = onAuthStateChanged(getAuth(), (u) => setUid(u?.uid || null));
    return () => unsub();
  }, []);

  useEffect(() => {
    if (!uid) {
      setBlockedIds([]);
      return;
    }
    const unsub = onSnapshot(
      collection(db, "users", uid, "blockedUsers"),
      (snap) => setBlockedIds(snap.docs.map((d) => d.id)),
      (err) => console.error("Blocked users listener error:", err)
    );
    return () => unsub();
  }, [uid]);

  const blockUser = useCallback(
    async (blockedUid) => {
      if (!uid || !blockedUid || uid === blockedUid) return;
      await setDoc(doc(db, "users", uid, "blockedUsers", blockedUid), {
        createdAt: serverTimestamp(),
      });
    },
    [uid]
  );

  return { blockedIds, blockUser };
}